import React, { useEffect } from "react"
import SplitTextJS from 'split-text-js'
import gsap from "gsap"

export default function ThreeDText () {
    // rotating '3d text' effect
    useEffect(() => {
        const titles = gsap.utils.toArray('p')
        const timeline = gsap.timeline({repeat: -1})
        
        // splits the words in the p tag into singular characters(letters) and adds an animation
        titles.forEach((title) => {
            const splitTitle = new SplitTextJS(title)
            
            timeline
            .from(splitTitle.chars, {
                opacity: 0,
                y: 80,
                rotateX: -90,
                stagger: 0.02
            }, '<')
            .to(splitTitle.chars, {
                opacity: 0,
                y: -80,
                rotateX: 90,
                stagger: 0.02
            }, '<2')
        })
    }, [])
        
    return (
        <div className="container">
            <div className="text-wrapper">
                <p>Front End Engineer</p>
                <p>Full Stack Engineer</p>
                <p>Designer</p>
                <p>Coffee Enthusiast</p>
                <p>Coffee Consultant</p>
                <p>Team Leader</p>
            </div>
        </div>
    )
}